var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-datepicker',{attrs:{"icon":"calendar-today","value":_vm.selectedDate,"max-date":_vm.maxDate,"min-date":new Date(_vm.minDate),"placeholder":_vm.placeholder},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }